import {useQuery} from "@tanstack/react-query";
import {getModelBySearchString, getModelColorItems} from "../../api/catalog";
import {useParams} from "react-router-dom";
import CatalogList from "./CatalogList";
import {MAX_MODEL_PER_SEARCH} from "../../Config";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../GlobalReducer";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";

export default function CatalogListBySearchString() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext)

    const {data: modelColorItemsData} = useQuery({
        queryKey: ['catalog', 'search', state.searchHistory[0] || null],
        queryFn: () => getModelBySearchString(state.searchHistory[0] || undefined),
        enabled: state.searchHistory.length > 0
    })

    const {
        model_color_items: modelColorItems,
        meta,
        category,
        breadcrumbs,
        banners,
        tags,
        super_categories,
        properties
    } = modelColorItemsData || {
        model_color_items: [],
        super_categories: [],
        meta: undefined,
        properties: []
    }

    return (<CatalogList modelColorItems={modelColorItems} meta={meta} category={category} breadcrumbs={breadcrumbs}
                         banners={banners} superCategories={super_categories} tags={tags} properties={properties}></CatalogList>)
}